import { Map } from 'immutable'

export const INITIAL_STATE = Map({
  checkGrantLoading: {},
  checkGrantErrorMessage: null,
  checkGrantsLoading: {},
  lastTimeGrantsChecked: {},
  getGrantsLoading: false,
  getGrantsErrorMessage: null,
  getGrantsForActiveUserLoading: false,
  getGrantsForActiveUserErrorMessage: null,
  createGrantLoading: false,
  createGrantErrorMessage: null,

  grantPermissions: [],
  grantListRequestStatuses: {},
  grantsForUser: {},
})
